export function formatCpf(document) {
    const digits = (document ?? '').replace(/\D/g, '').slice(0, 11);
    return digits
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
}
export function applyDateMask(value) {
    const digits = value.replace(/\D/g, '').slice(0, 8);
    return digits.replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');
}
export function isValidBirthDate(value) {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (!match) {
        return false;
    }
    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);
    const date = new Date(year, month - 1, day);
    const isRealDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    return isRealDate && date.getTime() <= Date.now();
}
export function dateToInputMask(date) {
    if (!date || Number.isNaN(date.getTime()) || date.getTime() === 0) {
        return '';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}/${month}/${year}`;
}
export function inputMaskToIsoDate(value) {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (!match) {
        return '';
    }
    return `${match[3]}-${match[2]}-${match[1]}`;
}
export function splitFullName(fullName) {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
        return { firstName: '', lastName: '' };
    }
    const [firstName, ...rest] = parts;
    return { firstName, lastName: rest.join(' ') };
}
export function findErrorMessage(errors, candidateKeys) {
    for (const errorRecord of errors) {
        if (!errorRecord) {
            continue;
        }
        for (const [key, message] of Object.entries(errorRecord)) {
            if (candidateKeys.some(candidate => key.toLowerCase() === candidate.toLowerCase())) {
                return message;
            }
        }
    }
    return undefined;
}
